import { apiClient } from '@/api/client';
import { AxiosResponse } from 'axios';
import { CartResponse } from '../types/api/cart';
import { mapCartResponseToCartModel } from '../types/mapper/cart';
import { CartGroup } from '../types/models/cart';

// 장바구니 담기
export const addToCart = async (productId: number): Promise<AxiosResponse> => {
  return await apiClient.post('/cart/items', {
    product_id: productId,
  });
};

// 장바구니 구매 요청
export const requestPurchase = async (
  cartItemId: number, 
  quantity: number, 
  paymentType: string
): Promise<AxiosResponse> => {
  // 결제조건을 백엔드 형식으로 변환
  const paymentTypeMap: Record<string, string> = {
    '즉시결제': 'immediate',
    '10일': '10_days',
    '20일': '20_days',
    '30일': '30_days',
    '40일': '40_days',
    '50일': '50_days',
    '60일': '60_days',
  };
  
  const backendPaymentType = paymentTypeMap[paymentType] || 'immediate';
  
  return await apiClient.post(`/cart/purchase`, {
    cart_item_id: cartItemId,
    quantity,
    payment_type: backendPaymentType,
  });
};

// 장바구니 삭제
export const removeFromCartByProductId = async (
  productId: number,
): Promise<AxiosResponse> => {
  return await apiClient.delete(`/cart/items?product_id=${productId}`);
};

export const removeFromCartById = async (
  cartId: number,
): Promise<AxiosResponse> => {
  return await apiClient.delete(`/cart/items/${cartId}`);
};

// 장바구니 조회
export const fetchCartItems = async (): Promise<CartGroup[]> => {
  return await apiClient
    .get<CartResponse>('/cart/items')
    .then((res) => mapCartResponseToCartModel(res.data));
};

// 장바구니 알림 전송
export const sendCartNotification = async (
  email: string,
): Promise<AxiosResponse> => {
  return await apiClient.post('/cart/notification', {
    email,
  });
};
